function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavouriteRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "19.96 18.65 25.27 13.35 18.64 13.35 16 6.07 13.34 13.35 6.74 13.35 12.03 18.65 8.72 25.93 14 22.62 16.39 21.04 16.39 21.04 14.7 19.34 17.72 16.31 19.96 18.65",
    style: {
      fill: "#e9c181"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.21 19.49 21.8 18.09 19.82 20.09 17.81 18.09 16.41 19.49 18.42 21.48 16.41 23.49 17.81 24.89 19.82 22.89 21.8 24.89 23.21 23.49 21.21 21.48 23.21 19.49",
    style: {
      fill: "#e44817"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteRemove);
export default __webpack_public_path__ + "static/media/favourite-remove.9ce8a41c.svg";
export { ForwardRef as ReactComponent };